import React, { useEffect, useState } from 'react';
import { bulkProgress } from '../../lib/commsBulk';
export default function BulkSendProgress({ client, orgId, jobId }) {
    const [rows, setRows] = useState([]), [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        const load = async () => {
            const result = await client.from('comms_bulk_recipients').select('status,reason').eq('org_id', orgId).eq('job_id', jobId);
            if (active) { if (result.error) setError('Could not refresh send progress.'); else { setRows(result.data || []); setError(''); } }
        };
        load(); const timer = setInterval(load, 3000);
        return () => { active = false; clearInterval(timer); };
    }, [client, orgId, jobId]);
    const progress = bulkProgress(rows);
    const cancel = async () => {
        const { data, error: failure } = await client.functions.invoke('comms-bulk', { body: { action: 'cancel', orgId, jobId } });
        if (failure || !data?.ok) setError(data?.error || 'Could not cancel this send.');
    };
    return <section aria-label="Send progress" className="rounded-lg border border-current p-3">
        <p role="status" aria-live="polite">{progress.sent} of {progress.total} sent, {progress.skipped} skipped ({rows.filter((row) => /opted_out/.test(row.reason || '')).length} opted out).</p>
        <progress max={progress.total || 1} value={progress.total - progress.remaining} aria-label="Recipients processed" />
        {progress.failed > 0 && <p>{progress.failed} failed.</p>}
        {progress.uncertain > 0 && <p>{progress.uncertain} deliveries are being checked. Do not resend.</p>}
        {progress.canceled > 0 && <p>{progress.canceled} canceled. An in-flight message may finish.</p>}
        {progress.remaining > 0 && <button type="button" className="ia-btn3d" onClick={cancel}>Cancel remaining sends</button>}
        {error && <p role="alert">{error}</p>}
    </section>;
}
